import React, { useState, useEffect } from "react";
import axios from "axios";
import { Modal, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import Loader from "../../pages/Loader";
import Snackbars from "../../pages/Snackbars";
import { checkauhtoken } from "../../../api/PrePageLoad";
import { formatBalance } from "../../../utils";
import MaterialTable from "@material-table/core";
import moment from 'moment';
import jsPDF from "jspdf";
import "jspdf-autotable";
import IBANKYCModal from "../shared/IBANKYCModal";

export const IBANAccount = () => {
  const [loader, setLoader] = useState(false);
  const [error, setError] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [success, setSuccess] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [refreshingAccount, setRefreshingAccount] = useState({});
  const [userDetails, setUserDetails] = useState(null);
  const [userAccounts, setUserAccounts] = useState([]);
  const [isIBANAccount, setIsIBANAccount] = useState("No");
  const [userIBANAccountsBalance, setUserIBANAccountsBalance] = useState({});
  const [siteFees, setSiteFees] = useState({});
  const [ibanBankAccount, setIBANBankAccount] = useState({});
  const [filter, setFilter] = useState({
    fromDate: "",
    toDate: "",
    transactionCurrency: "EUR",
  });
  const [ibanEURAccountTransactionHistory, setIBANEURAccountTransactionHistory] = useState([]);
  const [filteredIBANEURAccountTransactionHistory, setFilteredIBANEURAccountTransactionHistory] = useState([]);
  const [ibanUSDAccountTransactionHistory, setIBANUSDAccountTransactionHistory] = useState([]);
  const [filteredIBANUSDAccountTransactionHistory, setFilteredIBANUSDAccountTransactionHistory] = useState([]);
  const [showTransferModal, setShowTransferModal] = useState(false);
  const [transferFrom, setTransferFrom] = useState("IBAN EUR Account");
  const [transferTo, setTransferTo] = useState("Virtual EUR Wallet");
  const [transferCurrency, setTransferCurrency] = useState("EUR");
  const [transferAmount, setTransferAmount] = useState("");
  const [transferAmountError, setTransferAmountError] = useState("");
  const [showWithdrawalModal, setShowWithdrawalModal] = useState(false);
  const [formData, setFormData] = useState({
    beneficiary_iban_number: "",
    beneficiary_name: "",
    beneficiary_type: "INDIVIDUAL",
    withdrawal_amount: "",
    withdrawal_currency: "EUR",
    payment_description: "",
  });
  const [errors, setErrors] = useState({});
  const [showStatementDropdown, setShowStatementDropdown] = useState(false);
  const [beneficiaries, setBeneficiaries] = useState([]);
  const [selectedBeneficiary, setSelectedBeneficiary] = useState("");

  const headers = {
    "Content-Type": "application/json",
    useraccesstoken: process.env.REACT_APP_USER_ACCESS_TOKEN,
    userauthtoken: "Bearer " + window.sessionStorage.getItem("user_jwt"),
  };
  
  const [showIBANKYCModal, setShowIBANKYCModal] = useState(false);
  const handleKYCSuccess = (message) => {
    setSuccess(true);
    setSuccessMsg(message);
    setTimeout(() => {
      setSuccess(false);
    }, 6000);
  };
  const handleKYCError = (message) => {
    setError(true);
    setErrorMsg(message);
    setTimeout(() => {
      setError(false);
    }, 6000);
  };

  const handleOpenTransferModal = (currency = "EUR") => {
    setTransferCurrency(currency);
    if (currency === "EUR") {
      setTransferFrom("IBAN EUR Account");
      setTransferTo("Virtual EUR Wallet");
    } else if (currency === "USD") {
      setTransferFrom("IBAN USD Account");
      setTransferTo("Virtual USD Wallet");
    }
    setTransferAmount("");
    setTransferAmountError("");
    setShowTransferModal(true);
  };
  const handleCloseTransferModal = () => setShowTransferModal(false);
  const handleTransferSubmit = async () => {
    setTransferAmountError("");
    
    // Validation: amount required and > 0
    if (!transferAmount || isNaN(transferAmount) || Number(transferAmount) <= 0) {
      setTransferAmountError("Please enter a valid amount.");
      return;
    }

    // Validation: check available balance
    let availableBalance = 0;
    if (transferCurrency === "EUR") {
      availableBalance = Number(userIBANAccountsBalance.eurAvailableBalance || 0);
    } else if (transferCurrency === "USD") {
      availableBalance = Number(userIBANAccountsBalance.usdAvailableBalance || 0);
    }

    const amount = Number(transferAmount) || 0;
    const internalTransferFeesPercent = Number(siteFees.internalTransferFees || 0);
    const percentFee = amount * (internalTransferFeesPercent / 100);
    const totalRequiredTransferAmount = amount + percentFee;

    if (totalRequiredTransferAmount > availableBalance) {
      setTransferAmountError(`Insufficient balance. Total required (including fees): ${totalRequiredTransferAmount.toFixed(2)} ${transferCurrency}`);
      return;
    }

    setShowTransferModal(false);
    setLoader(true);
    try {
      const formData = {
        transfer_currency: transferCurrency,
        transfer_amount: transferAmount,
      };
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}account/transfer-account-to-wallet`,
        formData,
        { headers }
      );

      const res = response.data;

      if (res.code === "200") {
        setSuccess(true);
        setSuccessMsg(res.message);
        setTimeout(() => {
          setError(false);
          window.location.reload();
        }, 6000);
      } else {
        setError(true);
        setErrorMsg(res.message || "Something went wrong, please try again later.");
        setTimeout(() => {
          setError(false);
        }, 6000);
      }
    } catch (error) {
      console.error("Error during modal form submission:", error);

      setError(true);
      setErrorMsg("Something went wrong, please try again later.");
      setTimeout(() => {
        setError(false);
      }, 6000);
    } finally {
      setTransferAmount("");
      setTransferAmountError("");
      setLoader(false);
    }
  };

  // Add new state for tracking repeat payment
  const [isRepeatPayment, setIsRepeatPayment] = useState(false);

  const handleOpenWithdrawalModal = (currency = "EUR", rowData = null) => {
    if (rowData) {
      // If rowData is provided (repeat payment), pre-fill the form
      const shouldIncludeNarrative = 
      rowData.narrative;

      // Find matching beneficiary by IBAN number
      const matchingBeneficiary = beneficiaries.find(
        b => b.beneficiary_iban_number === rowData.beneficiary_iban_number
      );

      if (matchingBeneficiary) {
        // If beneficiary exists in the list, auto-select it
        setSelectedBeneficiary(matchingBeneficiary.beneficiary_id);
        setFormData({
          beneficiary_iban_number: rowData.beneficiary_iban_number || "",
          beneficiary_name: matchingBeneficiary.beneficiary_name,
          beneficiary_type: matchingBeneficiary.beneficiary_type,
          withdrawal_amount: rowData.amount || "",
          withdrawal_currency: currency,
          payment_description: shouldIncludeNarrative ? rowData.narrative : "",
        });
      } else {
        // If beneficiary doesn't exist in the list, just fill the IBAN
        setSelectedBeneficiary("");
        setFormData({
          beneficiary_iban_number: rowData.beneficiary_iban_number || "",
          beneficiary_name: "",
          beneficiary_type: "INDIVIDUAL",
          withdrawal_amount: rowData.amount || "",
          withdrawal_currency: currency,
          payment_description: shouldIncludeNarrative ? rowData.narrative : "",
        });
      }
      setIsRepeatPayment(true);
    } else {
      // Normal withdrawal modal
      setFormData({
        beneficiary_iban_number: "",
        beneficiary_name: "",
        beneficiary_type: "INDIVIDUAL",
        withdrawal_amount: "",
        withdrawal_currency: currency,
        payment_description: "",
      });
      setSelectedBeneficiary("");
      setIsRepeatPayment(false);
    }
    setErrors({});
    setShowWithdrawalModal(true);
  };
  const handleCloseWithdrawalModal = () => {
    setShowWithdrawalModal(false);
    setIsRepeatPayment(false);
  };
  const handleInputChange = (e) => {
      const { name, value } = e.target;
      setFormData((prev) => ({
          ...prev,
          [name]: value,
      }));
      setErrors((prev) => ({
          ...prev,
          [name]: "",
      }));
  };
  const validateForm = () => {
    const newErrors = {};

    // Common validations
    if (!formData.beneficiary_iban_number) newErrors.beneficiary_iban_number = "IBAN Number is required";
    if (!formData.beneficiary_name) newErrors.beneficiary_name = "Beneficiary Name is required";
    if (!formData.withdrawal_amount) newErrors.withdrawal_amount = "Amount is required";
    if (!formData.withdrawal_currency) newErrors.withdrawal_currency = "Currency is required";
    
    // Payment description validation
    if (!formData.payment_description) {
        newErrors.payment_description = "Payment description is required";
    } else if (formData.payment_description.trim().length < 10) {
        newErrors.payment_description = "Payment description must be at least 10 characters";
    } else if (!/^[a-zA-Z0-9\s.\-_]+$/.test(formData.payment_description)) {
        newErrors.payment_description = "Payment description can only contain letters, numbers, spaces, dots, hyphens, and underscores";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleWithdrawalSubmit = async () => {
      if (validateForm()) {
          setErrors({});

          // Validation: amount required and > 0
          if (!formData.withdrawal_amount || isNaN(formData.withdrawal_amount) || Number(formData.withdrawal_amount) <= 0) {
            setErrors((prev) => ({
                ...prev,
                withdrawal_amount: "Please enter a valid amount.",
            }));
            return;
          }

          // Validation: check available balance
          let availableBalance = 0;
          if (formData.withdrawal_currency === "EUR") {
            availableBalance = Number(userIBANAccountsBalance.eurAvailableBalance || 0);
          } else if (formData.withdrawal_currency === "USD") {
            availableBalance = Number(userIBANAccountsBalance.usdAvailableBalance || 0);
          }

          const amount = Number(formData.withdrawal_amount) || 0;
          const withdrawalFeePercent = Number(siteFees.withdrawalFees || 0);
          const percentFee = amount * (withdrawalFeePercent / 100);
          const totalRequiredWithdrawalAmount = amount + percentFee;

          if (totalRequiredWithdrawalAmount > availableBalance) {
            setErrors((prev) => ({
                ...prev,
                withdrawal_amount: `Insufficient balance. Total required (including fees): ${totalRequiredWithdrawalAmount.toFixed(2)} ${formData.withdrawal_currency}`,
            }));
            return;
          }

          setShowWithdrawalModal(false);
          setLoader(true);
          try {
          const response = await axios.post(
              `${process.env.REACT_APP_API_URL}account/withdrawal-account-to-external-account`,
              formData,
              { headers }
          );
      
          const res = response.data;
      
          if (res.code === "200") {
              setSuccess(true);
              setSuccessMsg(res.message);
              setTimeout(() => {
              setError(false);
              window.location.reload();
              }, 6000);
          } else {
              setError(true);
              setErrorMsg(res.message || "Something went wrong, please try again later.");
              setTimeout(() => {
              setError(false);
              }, 6000);
          }
          } catch (error) {
          console.error("Error during form submission:", error);

          setError(true);
          setErrorMsg("Something went wrong, please try again later.");
          setTimeout(() => {
              setError(false);
          }, 6000);
          } finally {
          setLoader(false);
          }
      }
  }

  const handleSearchTransactions = () => {
    let eurData = ibanEURAccountTransactionHistory;
    let usdData = ibanUSDAccountTransactionHistory;
  
    if (filter.fromDate) {
      eurData = eurData.filter(tx =>
        moment(tx.transaction_date).isSameOrAfter(moment(filter.fromDate, "YYYY-MM-DD"), "day")
      );
      usdData = usdData.filter(tx =>
        moment(tx.transaction_date).isSameOrAfter(moment(filter.fromDate, "YYYY-MM-DD"), "day")
      );
    }
    if (filter.toDate) {
      eurData = eurData.filter(tx =>
        moment(tx.transaction_date).isSameOrBefore(moment(filter.toDate, "YYYY-MM-DD"), "day")
      );
      usdData = usdData.filter(tx =>
        moment(tx.transaction_date).isSameOrBefore(moment(filter.toDate, "YYYY-MM-DD"), "day")
      );
    }

    setFilteredIBANEURAccountTransactionHistory(eurData);
    setFilteredIBANUSDAccountTransactionHistory(usdData);
  };

  const handleResetTransactions = () => {
    setFilter(prev => ({
      ...prev,
      fromDate: "",
      toDate: ""
    }));
    setFilteredIBANEURAccountTransactionHistory(ibanEURAccountTransactionHistory);
    setFilteredIBANUSDAccountTransactionHistory(ibanUSDAccountTransactionHistory);
  };

  const [selectedEURRows, setSelectedEURRows] = useState([]);
  const [selectedUSDRows, setSelectedUSDRows] = useState([]);

  // Function to handle individual checkbox toggle
  const handleRowSelection = (rowData, isChecked) => {
    const isEUR = filter.transactionCurrency === "EUR";
    
    if (isEUR) {
      if (isChecked) {
        // Add to selected rows
        setSelectedEURRows(prev => [...prev, rowData]);
      } else {
        // Remove from selected rows
        setSelectedEURRows(prev => prev.filter(row => row.ibanabs_id !== rowData.ibanabs_id));
      }
    } else {
      if (isChecked) {
        // Add to selected rows
        setSelectedUSDRows(prev => [...prev, rowData]);
      } else {
        // Remove from selected rows
        setSelectedUSDRows(prev => prev.filter(row => row.ibanabs_id !== rowData.ibanabs_id));
      }
    }
  };

  // Function to handle "select all" checkbox
  const handleSelectAll = (isChecked) => {
    const isEUR = filter.transactionCurrency === "EUR";
    const currentData = isEUR ? filteredIBANEURAccountTransactionHistory : filteredIBANUSDAccountTransactionHistory;
    
    if (isChecked) {
      // Select all rows
      if (isEUR) {
        setSelectedEURRows([...currentData]);
      } else {
        setSelectedUSDRows([...currentData]);
      }
    } else {
      // Deselect all rows
      if (isEUR) {
        setSelectedEURRows([]);
      } else {
        setSelectedUSDRows([]);
      }
    }
  };

  // Function to check if a row is selected
  const isRowSelected = (rowData) => {
    const isEUR = filter.transactionCurrency === "EUR";
    const selectedRows = isEUR ? selectedEURRows : selectedUSDRows;
    return selectedRows.some(row => row.ibanabs_id === rowData.ibanabs_id);
  };

  // Function to check if all rows are selected
  const isAllSelected = () => {
    const isEUR = filter.transactionCurrency === "EUR";
    const currentData = isEUR ? filteredIBANEURAccountTransactionHistory : filteredIBANUSDAccountTransactionHistory;
    const selectedRows = isEUR ? selectedEURRows : selectedUSDRows;
    
    return currentData.length > 0 && selectedRows.length === currentData.length;
  };

  // Update the currency change handler to clear selections
  const handleCurrencyChange = (currencyValue) => {
    // Clear selections when currency changes
    setSelectedEURRows([]);
    setSelectedUSDRows([]);
    setFilter((prev) => ({
      ...prev,
      fromDate: "",
      toDate: "",
      transactionCurrency: currencyValue,
    }));
    setFilteredIBANEURAccountTransactionHistory(
      ibanEURAccountTransactionHistory
    );
    setFilteredIBANUSDAccountTransactionHistory(
      ibanUSDAccountTransactionHistory
    );
  };

  const handleDownloadStatement = (filterType = "ALL") => {
    const isEUR = filter.transactionCurrency === "EUR";
    const selectedRows = isEUR ? selectedEURRows : selectedUSDRows;
    let allData = isEUR ? filteredIBANEURAccountTransactionHistory : filteredIBANUSDAccountTransactionHistory;

    if (filterType !== "ALL") {
      allData = allData.filter(row => row.payment_status === filterType);
    }

    // Use selected rows if any are selected, otherwise use filtered data
    const data = selectedRows.length > 0 ? 
      (filterType !== "ALL" ? selectedRows.filter(row => row.payment_status === filterType) : selectedRows) 
      : allData;
    
    if(data.length === 0) {
      setError(true);
      setErrorMsg(filterType === "ALL" 
        ? "Transaction history not available" 
        : `No transactions found with status: ${filterType}`);
      setTimeout(() => {
        setError(false);
      }, 6000);
      return;
    }

    // Bank and account details
    const bankDetails = [
      [`Bank Name:`, (userAccounts.find(acc => acc.account_currency_type === filter.transactionCurrency)?.new_iban_bank_name) || ibanBankAccount.iban_bank_name || "-"],
      [`Swift Code:`, (userAccounts.find(acc => acc.account_currency_type === filter.transactionCurrency)?.new_iban_swift_code) || ibanBankAccount.iban_swift_code || "-"],
      [`Bank Address:`, (userAccounts.find(acc => acc.account_currency_type === filter.transactionCurrency)?.new_iban_bank_address) || ibanBankAccount.iban_bank_address || "-"],
      [`Account Name:`, userDetails ? `${userDetails.first_name} ${userDetails.last_name}` : "-"],
      // [`Account Number:`, (userAccounts.find(acc => acc.account_currency_type === filter.transactionCurrency)?.account_number) || "-"],
      [`IBAN Number:`, (userAccounts.find(acc => acc.account_currency_type === filter.transactionCurrency)?.new_iban_number) || "-"],
      [`Currency:`, filter.transactionCurrency],
    ];

    const doc = new jsPDF();
    doc.setFontSize(16);
    doc.text(`${isEUR ? "EUR" : "USD"} Account Statement`, 14, 18);
  
    // Add bank/account details (all same font and size)
    doc.setFontSize(11);
    let y = 26;
    bankDetails.forEach(([label, value]) => {
      doc.text(`${label} ${value}`, 14, y);
      y += 6;
    });

    // Add period if filtered
    let period = "";
    if (filter.fromDate || filter.toDate) {
      period = `Period: ${filter.fromDate || "Start"} - ${filter.toDate || "End"}`;
      doc.setFontSize(10);
      doc.text(period, 14, y);
      y += 8;
    } else {
      y += 2;
    }
  
    // Transaction Table
    doc.autoTable({
      startY: y,
      head: [[
        "Date",
        "Sender",
        "Recipient",
        "Status",
        "Debit/Credit",
        "Amount",
        "Network Fee",
        "Site Fee"
      ]],
      body: data.map(row => {
        let displayAmount = Number(row.amount);
        if (
          row.debit_credit === "CREDIT" &&
          row.payment_type === "INTERNAL"
        ) {
          displayAmount += Number(row.site_fee || 0);
        }
        return [
          moment(row.transaction_date).format('YYYY-MM-DD HH:mm:ss'),
          row.sender || "-",
          row.recipient || "-",
          row.payment_status,
          row.debit_credit,
          (row.currency === "EUR" ? "€" : "$") +
            displayAmount.toLocaleString(undefined, { minimumFractionDigits: 2 }),
          (row.currency === "EUR" ? "€" : "$") +
            (isNaN(Number(row.network_fee))
              ? "0.00"
              : Number(row.network_fee).toLocaleString(undefined, { minimumFractionDigits: 2 })),
          (row.currency === "EUR" ? "€" : "$") +
            Number(row.site_fee).toLocaleString(undefined, { minimumFractionDigits: 2 }),
        ];
      }),
      styles: { fontSize: 9 },
      headStyles: { fillColor: [30, 170, 231] }
    });
  
    doc.save(`${isEUR ? "EUR" : "USD"}_Account_Statement.pdf`);
  };

  const handleDownloadBankProof = () => {
    // Check if we have bank account details
    if (!ibanBankAccount.iban_bank_name && !userDetails) {
      setError(true);
      setErrorMsg("Bank account details not available");
      setTimeout(() => {
        setError(false);
      }, 6000);
      return;
    }

    // Bank and account details for proof
    const bankDetails = [
      [`Bank Name:`, (userAccounts.find(acc => acc.account_currency_type === "EUR")?.new_iban_bank_name) || ibanBankAccount.iban_bank_name || "-"],
      [`Swift Code:`, (userAccounts.find(acc => acc.account_currency_type === "EUR")?.new_iban_swift_code) || ibanBankAccount.iban_swift_code || "-"],
      [`Bank Address:`, (userAccounts.find(acc => acc.account_currency_type === "EUR")?.new_iban_bank_address) || ibanBankAccount.iban_bank_address || "-"],
      [`Account Holder Name:`, userDetails ? `${userDetails.first_name} ${userDetails.last_name}` : "-"],
      // [`Account Number (EUR):`, (userAccounts.find(acc => acc.account_currency_type === "EUR")?.account_number) || "-"],
      [`IBAN Number (EUR):`, (userAccounts.find(acc => acc.account_currency_type === "EUR")?.new_iban_number) || "-"],
      // [`Account Number (USD):`, (userAccounts.find(acc => acc.account_currency_type === "USD")?.account_number) || "-"],
      // [`IBAN Number (USD):`, (userAccounts.find(acc => acc.account_currency_type === "USD")?.new_iban_number) || "-"],
      [`Account Status (EUR):`, (userAccounts.find(acc => acc.account_currency_type === "EUR")?.new_iban_number) ? "Active" : "Inactive"],
      // [`Account Status (USD):`, (userAccounts.find(acc => acc.account_currency_type === "USD")?.new_iban_number) ? "Active" : "Inactive"],
      [`Document Generated:`, moment().format('YYYY-MM-DD HH:mm:ss')],
    ];

    const doc = new jsPDF();
    
    // Header
    doc.setFontSize(18);
    doc.setFont("helvetica", "bold");
    doc.text("ACCOUNT CONFIRMATION", 105, 20, { align: "center" });
    
    // Subheader
    doc.setFontSize(14);
    doc.setFont("helvetica", "normal");
    doc.text("Official Bank Account Details Verification", 105, 30, { align: "center" });
    
    // Add a line separator
    doc.setLineWidth(0.5);
    doc.line(14, 35, 196, 35);
    
    // Account holder information section
    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    doc.text("ACCOUNT HOLDER INFORMATION", 14, 45);
    
    // Add bank/account details
    doc.setFontSize(11);
    doc.setFont("helvetica", "normal");
    let y = 55;
    bankDetails.forEach(([label, value]) => {
      // Make labels bold
      doc.setFont("helvetica", "bold");
      doc.text(label, 14, y);
      
      // Make values normal
      doc.setFont("helvetica", "normal");
      doc.text(value, 80, y);
      y += 8;
    });
    
    // Add verification section
    y += 10;
    doc.setLineWidth(0.3);
    doc.line(14, y, 196, y);
    y += 10;
    
    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    doc.text("VERIFICATION", 14, y);
    y += 10;
    
    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    const verificationText = [
      "This document serves as proof of bank account ownership and details.",
      "The information contained herein is accurate as of the date of generation.",
      "This document can be used for official verification purposes.",
    ];
    
    verificationText.forEach(text => {
      doc.text(text, 14, y);
      y += 6;
    });
    
    // Add footer
    y = 280; // Fixed position at bottom
    doc.setLineWidth(0.3);
    doc.line(14, y - 5, 196, y - 5);
    
    doc.setFontSize(8);
    doc.setFont("helvetica", "italic");
    doc.text("This is a system-generated document and does not require a signature.", 105, y, { align: "center" });
    doc.text(`Generated on: ${moment().format('YYYY-MM-DD HH:mm:ss')}`, 105, y + 5, { align: "center" });
    
    // Save the PDF
    doc.save("Account_Confirmation.pdf");
  };

  const getUniquePaymentStatuses = () => {
    const data = filter.transactionCurrency === "EUR" 
      ? filteredIBANEURAccountTransactionHistory 
      : filteredIBANUSDAccountTransactionHistory;
    
    const statuses = [...new Set(data.map(row => row.payment_status))].filter(Boolean);
    return statuses.sort();
  };

  const handleLoadGetUserAccounts = async () => {
    setLoader(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}account/getuseraccoundsbyid`,
        { headers }
      );
      const res = response.data;
      if (res.code === "200") {
        setUserAccounts(res.data);
        setIsIBANAccount(
          res.data?.some((account) => account?.is_new_iban_account === "Yes") 
            ? "Yes" 
            : "No"
        );
      } else {
        console.error("Failed to fetch user accounts");
      }
    } catch (error) {
        console.error("Error fetching user accounts:", error);
    } finally {
      handleLoadGetUserDetails();
    }
  };
  
  const handleLoadGetUserDetails = async () => {
    setLoader(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}getUserDetails`,
        { headers }
      );
      const res = response.data;
      if (res.code === "200") {
        setUserDetails(res.data);
      } else {
        console.error("Failed to fetch user details");
      }
    } catch (error) {
      console.error("Error fetching user details:", error);
    } finally {
      handleLoadGetUserIBANAccountsBalance();
    }
  };

  const handleLoadGetUserIBANAccountsBalance = async (isLoaderStart = true) => {
    if (isLoaderStart) {
      setLoader(true);
    }
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}account/get-user-iban-accounts-balance`,
        { headers }
      );
      const res = response.data;
      if (res.code === "200") {
        setUserIBANAccountsBalance(res.data);
        setSiteFees(res.site_fees);
      } else {
        console.error("Failed to fetch user iban accounts balance");
      }
    } catch (error) {
      console.error("Error fetching user iban accounts balance:", error);
    } finally {
      handleLoadGetIBANBankAccount(isLoaderStart);
    }
  };

  const handleLoadGetIBANBankAccount = async (isLoaderStart = true) => {
    if (isLoaderStart) {
      setLoader(true);
    }
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}account/get-iban-bank-account`,
        { headers }
      );
      const res = response.data;
      if (res.code === "200") {
        setIBANBankAccount(res.data);
      } else {
        console.error("Failed to fetch iban bank account");
      }
    } catch (error) {
      console.error("Error fetching iban bank account:", error);
    } finally {
      handleLoadGetIBANAccountTransactionHistory(isLoaderStart);
    }
  };

  const handleLoadGetIBANAccountTransactionHistory = async (isLoaderStart = true) => {
    if (isLoaderStart) {
      setLoader(true);
    }
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}account/get-iban-account-transaction-history`,
        { headers }
      );
      const res = response.data;
      if (res.code === "200") {
        setIBANEURAccountTransactionHistory(res.data.userIBANEURAccountBalancesheet);
        setFilteredIBANEURAccountTransactionHistory(res.data.userIBANEURAccountBalancesheet);
        setIBANUSDAccountTransactionHistory(res.data.userIBANUSDAccountBalancesheet);
        setFilteredIBANUSDAccountTransactionHistory(res.data.userIBANUSDAccountBalancesheet);
      } else {
        console.error("Failed to fetch iban account transaction history");
      }
    } catch (error) {
      console.error("Error fetching iban account transaction history:", error);
    } finally {
      handleLoadGetBeneficiaries();
    }
  };

  const handleLoadGetBeneficiaries = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}account/get-beneficiaries`,
        { headers }
      );
      const res = response.data;
      if (res.code === "200") {
        setBeneficiaries(res.data || []);
      }
    } catch (error) {
      console.error("Error fetching beneficiaries:", error);
    } finally {
      setLoader(false);
    }
  };

  const handleBeneficiarySelect = (beneficiary_id) => {
    if (beneficiary_id) {
      setSelectedBeneficiary(beneficiary_id);
      const beneficiary = beneficiaries.find(b => parseInt(b.beneficiary_id) === parseInt(beneficiary_id));
      setFormData((prev) => ({
        ...prev,
        beneficiary_iban_number: beneficiary.beneficiary_iban_number,
        beneficiary_name: beneficiary.beneficiary_name,
        beneficiary_type: beneficiary.beneficiary_type,
      }));
    } else {
      setSelectedBeneficiary("");
      setFormData((prev) => ({
        ...prev,
        beneficiary_iban_number: "",
        beneficiary_name: "",
        beneficiary_type: "INDIVIDUAL",
      }));
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showStatementDropdown && !event.target.closest('.btn-group')) {
        setShowStatementDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showStatementDropdown]);

  useEffect(() => {
    checkauhtoken();
    handleLoadGetUserAccounts();
    // eslint-disable-next-line
  }, []);


  return (
    <>
    {error && <Snackbars open_close={error} type="error" message={errorMsg} />}
    {success && <Snackbars open_close={success} type="success" message={successMsg} />}
    {loader ? (
      <Loader open_close={loader} />
    ) : (
      <>
        <div className="">
          <div className="form-head mb-4">
              <h2 className="text-black font-w500 mb-0">IBAN Accounts</h2>
          </div>
          {/* IBAN KYC Modal */}
          <IBANKYCModal
            show={showIBANKYCModal}
            onHide={() => setShowIBANKYCModal(false)}
            onSuccess={handleKYCSuccess}
            onError={handleKYCError}
          />
        {isIBANAccount === "No" ? (
            <div className="card">
                <div className="card-body text-center">
                  <h5 className="text-black mb-3">Your IBAN account is currently not available.</h5>
                  <p className="text-muted mb-4">Complete your KYC verification to activate your IBAN account.</p>
                  <button
                    className="btn btn-primary btn-rounded"
                    onClick={() => setShowIBANKYCModal(true)}
                  >
                    <i className="fa fa-id-card mr-2"></i> Apply for IBAN Account
                  </button>
                </div>
            </div>
        ) : (
          <>
            <div className="row">
            {userAccounts.length > 0 ? (
              <>
              {userAccounts.map((account, index) => (
                <div className="col-xl-6" key={index}>
                  <div className="card">
                    <div className="card-header flex-wrap border-0 pb-0 align-items-end walletBox">
                      <div className="d-flex align-items-center mr-3">
                        <svg
                          className="mr-3 color-primary"
                          width="45"
                          height="45"
                          viewBox="0 0 68 68"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M59.4999 31.688V19.8333C59.4999 19.0818 59.2014 18.3612 58.6701 17.8298C58.1387 17.2985 57.418 17 56.6666 17H11.3333C10.5818 17 9.86114 16.7014 9.32978 16.1701C8.79843 15.6387 8.49992 14.9181 8.49992 14.1666C8.49992 13.4152 8.79843 12.6945 9.32978 12.1632C9.86114 11.6318 10.5818 11.3333 11.3333 11.3333H56.6666C57.418 11.3333 58.1387 11.0348 58.6701 10.5034C59.2014 9.97208 59.4999 9.25141 59.4999 8.49996C59.4999 7.74851 59.2014 7.02784 58.6701 6.49649C58.1387 5.96514 57.418 5.66663 56.6666 5.66663H11.3333C9.07891 5.66663 6.9169 6.56216 5.32284 8.15622C3.72878 9.75028 2.83325 11.9123 2.83325 14.1666V53.8333C2.83325 56.0876 3.72878 58.2496 5.32284 59.8437C6.9169 61.4378 9.07891 62.3333 11.3333 62.3333H56.6666C57.418 62.3333 58.1387 62.0348 58.6701 61.5034C59.2014 60.9721 59.4999 60.2514 59.4999 59.5V47.6453C61.1561 47.0683 62.5917 45.9902 63.6076 44.5605C64.6235 43.1308 65.1693 41.4205 65.1693 39.6666C65.1693 37.9128 64.6235 36.2024 63.6076 34.7727C62.5917 33.3431 61.1561 32.265 59.4999 31.688ZM53.8333 56.6666H11.3333C10.5818 56.6666 9.86114 56.3681 9.32978 55.8368C8.79843 55.3054 8.49992 54.5847 8.49992 53.8333V22.1453C9.40731 22.4809 10.3658 22.6572 11.3333 22.6666H53.8333V31.1666H45.3333C43.0789 31.1666 40.9169 32.0622 39.3228 33.6562C37.7288 35.2503 36.8333 37.4123 36.8333 39.6666C36.8333 41.921 37.7288 44.083 39.3228 45.677C40.9169 47.2711 43.0789 48.1666 45.3333 48.1666H53.8333V56.6666ZM56.6666 42.5H45.3333C44.5818 42.5 43.8611 42.2015 43.3298 41.6701C42.7984 41.1387 42.4999 40.4181 42.4999 39.6666C42.4999 38.9152 42.7984 38.1945 43.3298 37.6632C43.8611 37.1318 44.5818 36.8333 45.3333 36.8333H56.6666C57.418 36.8333 58.1387 37.1318 58.6701 37.6632C59.2014 38.1945 59.4999 38.9152 59.4999 39.6666C59.4999 40.4181 59.2014 41.1387 58.6701 41.6701C58.1387 42.2015 57.418 42.5 56.6666 42.5Z"
                            fill="#1EAAE7"
                          />
                        </svg>
                        <div className="mr-auto">
                          <div className="d-flex align-items-center">
                            <h5 className="text-black mb-0">
                              Available Balance
                            </h5>
                            <button
                              className="btn btn-light btn-circle"
                              title={`Refresh Balance`}
                              style={{
                                borderRadius: "50%",
                                width: "38px",
                                height: "38px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center"
                              }}
                              onClick={async () => {
                                setRefreshingAccount(prev => ({ ...prev, [account.account_number]: true }));
                                await handleLoadGetUserIBANAccountsBalance(false);
                                setRefreshingAccount(prev => ({ ...prev, [account.account_number]: false }));
                              }}
                              aria-label="Refresh Balance"
                              disabled={!!refreshingAccount[account.account_number]}
                            >
                              <i
                                className={`fa fa-refresh${refreshingAccount[account.account_number] ? " fa-spin" : ""}`}
                                style={{ fontSize: "1.2rem" }}
                              ></i>
                            </button>
                          </div>
                          <span className="text-num text-black">
                            {account.account_currency_type === "EUR" ? "€ " : account.account_currency_type === "USD" ? "$ " : ""}
                            {account.account_currency_type === "EUR"
                              ? formatBalance(userIBANAccountsBalance.eurAvailableBalance)
                              : account.account_currency_type === "USD"
                              ? formatBalance(userIBANAccountsBalance.usdAvailableBalance)
                              : "0.00"}
                          </span>
                        </div>
                      </div>
                    </div>
                    {/* Bank Details Section */}
                    <div className="card-body pt-3">
                      <div className="d-flex align-items-center mb-3 mt-2">
                        <h6
                          className="text-black mb-0"
                          style={{
                            fontWeight: 700,
                            fontSize: "1.15rem",
                            letterSpacing: "0.5px",
                            textTransform: "uppercase",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <i className="fa fa-university mr-2 color-primary" aria-hidden="true"></i>
                          Bank Details
                        </h6>
                      </div>
                      {account.account_currency_type === "EUR" ? (
                        <>
                          {(ibanBankAccount.iban_bank_name || account.new_iban_bank_name) && (
                          <div className="mb-2">
                            <strong>Bank Name:</strong> {account.new_iban_bank_name ? account.new_iban_bank_name : ibanBankAccount.iban_bank_name}
                            <button
                              className="btn btn-link btn-sm ml-2"
                              onClick={() => navigator.clipboard.writeText(account.new_iban_bank_name ? account.new_iban_bank_name : ibanBankAccount.iban_bank_name || "")}
                              title="Copy to clipboard"
                            >
                              <i className="fa fa-copy"></i>
                            </button>
                          </div>
                          )}
                          {(ibanBankAccount.iban_swift_code || account.new_iban_swift_code) && (
                          <div className="mb-2">
                            <strong>Swift Code:</strong> {account.new_iban_swift_code ? account.new_iban_swift_code : ibanBankAccount.iban_swift_code}
                            <button
                              className="btn btn-link btn-sm ml-2"
                              onClick={() => navigator.clipboard.writeText(account.new_iban_swift_code ? account.new_iban_swift_code : ibanBankAccount.iban_swift_code || "")}
                              title="Copy to clipboard"
                            >
                              <i className="fa fa-copy"></i>
                            </button>
                          </div>
                          )}
                          {(ibanBankAccount.iban_bank_address || account.new_iban_bank_address) && (
                          <div className="mb-2">
                            <strong>Bank Address:</strong>{" "}
                            <span style={{ wordWrap: "break-word", whiteSpace: "normal" }}>
                              {account.new_iban_bank_address ? account.new_iban_bank_address : ibanBankAccount.iban_bank_address}
                            </span>
                            <button
                              className="btn btn-link btn-sm ml-2"
                              onClick={() => navigator.clipboard.writeText(account.new_iban_bank_address ? account.new_iban_bank_address : ibanBankAccount.iban_bank_address || "")}
                              title="Copy to clipboard"
                            >
                              <i className="fa fa-copy"></i>
                            </button>
                          </div>
                          )}
                          <div className="mb-2">
                            <strong>Account Name:</strong> {userDetails.first_name} {userDetails.last_name}
                            <button
                              className="btn btn-link btn-sm ml-2"
                              onClick={() => navigator.clipboard.writeText(userDetails.first_name + " " + userDetails.last_name || "")}
                              title="Copy to clipboard"
                            >
                              <i className="fa fa-copy"></i>
                            </button>
                          </div>
                          {/* <div className="mb-2">
                            <strong>Account Number:</strong> {account.account_number || "-"}
                            <button
                              className="btn btn-link btn-sm ml-2"
                              onClick={() => navigator.clipboard.writeText(account.account_number || "")}
                              title="Copy to clipboard"
                            >
                              <i className="fa fa-copy"></i>
                            </button>
                          </div> */}
                          <div className="mb-2">
                            <strong>IBAN Number:</strong> {account.new_iban_number || "-"}
                            <button
                              className="btn btn-link btn-sm ml-2"
                              onClick={() => navigator.clipboard.writeText(account.new_iban_number || "")}
                              title="Copy to clipboard"
                            >
                              <i className="fa fa-copy"></i>
                            </button>
                          </div>
                          <div className="mb-2">
                            <strong>Currency:</strong> {account.account_currency_type || "-"}
                            <button
                              className="btn btn-link btn-sm ml-2"
                              onClick={() => navigator.clipboard.writeText(account.account_currency_type || "")}
                              title="Copy to clipboard"
                            >
                              <i className="fa fa-copy"></i>
                            </button>
                          </div>
                          <div className="mt-3 d-flex justify-content-start">
                            <button
                              className="btn btn-primary btn-rounded"
                              onClick={() => handleOpenWithdrawalModal("EUR")}
                            >
                              <i className="flaticon-381-folder-4"></i> Withdrawal
                            </button>

                            {userDetails.account_type !== "Bank" && (
                              <button
                                className="btn btn-primary btn-rounded ml-3"
                                onClick={() => handleOpenTransferModal("EUR")}
                              >
                                <i className="fa fa-exchange mt-1"></i> Transfer
                              </button>
                            )}
                          </div>
                        </>
                      ) : account.account_currency_type === "USD" ? (
                        <div className="alert alert-warning mb-0">
                          <i className="fa fa-info-circle mr-2"></i>
                          USD bank details are currently not available.
                        </div>
                      ) : (
                        <div className="text-muted">No bank details available.</div>
                      )}
                    </div>
                  </div>
                </div>
              ))}
              {/* Transaction Table - only once, after all accounts */}
              <div className="col-xl-12">
                <div className="card">
                  <div className="card-header" style={{ justifyContent: "unset !important" }}>
                    <div className="form-group mb-0 mr-4">
                      <label className="mb-2">Currency</label>
                      <select
                        className="form-control w-auto"
                        value={filter.transactionCurrency}
                        onChange={e => handleCurrencyChange(e.target.value)}
                      >
                        <option value="EUR">EUR</option>
                        <option value="USD">USD</option>
                      </select>
                    </div>
                    <div className="form-group mb-0 mr-4">
                      <label className="mb-2">From Date</label>
                      <input
                        type="date"
                        className="form-control"
                        value={filter.fromDate}
                        onChange={e => setFilter({ ...filter, fromDate: e.target.value })}
                        max={filter.toDate || undefined}
                      />
                    </div>
                    <div className="form-group mb-0 mr-4">
                      <label className="mb-2">To Date</label>
                      <input
                        type="date"
                        className="form-control"
                        value={filter.toDate}
                        onChange={e => setFilter({ ...filter, toDate: e.target.value })}
                        min={filter.fromDate || undefined}
                      />
                    </div>
                    <div className="mb-0 mr-4">
                    <label className="mb-2">&nbsp;</label>
                      <button
                        className="btn btn-primary btn-rounded"
                        style={{ width: "100%" }}
                        onClick={handleSearchTransactions}
                      >
                        Search
                      </button>
                    </div>
                    <div className="mb-0 mr-4">
                      <label className="mb-2">&nbsp;</label>
                      <button
                        className="btn btn-light btn-rounded"
                        style={{ width: "100%" }}
                        onClick={handleResetTransactions}
                      >
                        Reset
                      </button>
                    </div>
                    <div className="mb-0 mr-4 position-relative">
                      <label className="mb-2">&nbsp;</label>
                      <div className="btn-group w-100">
                        <button
                          className="btn btn-success btn-rounded dropdown-toggle"
                          type="button"
                          onClick={() => setShowStatementDropdown(!showStatementDropdown)}
                          style={{ width: "100%" }}
                        >
                          <i className="fa fa-download"></i> Statement
                        </button>
                        {showStatementDropdown && (
                          <div 
                            className="dropdown-menu show" 
                            style={{ 
                              position: 'absolute', 
                              top: '100%', 
                              left: 0, 
                              right: 0, 
                              zIndex: 1000,
                              minWidth: '200px'
                            }}
                          >
                            <button 
                              className="dropdown-item" 
                              onClick={() => handleDownloadStatement("ALL")}
                            >
                              <i className="fa fa-file-pdf-o mr-2"></i>All Transactions
                            </button>
                            <div className="dropdown-divider"></div>
                            {getUniquePaymentStatuses().map(status => (
                              <button 
                                key={status}
                                className="dropdown-item" 
                                onClick={() => handleDownloadStatement(status)}
                              >
                                <i className="fa fa-filter mr-2"></i>{status} Only
                              </button>
                            ))}
                            {getUniquePaymentStatuses().length === 0 && (
                              <span className="dropdown-item-text text-muted">
                                <i className="fa fa-info-circle mr-2"></i>No data available
                              </span>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="mb-0">
                      <label className="mb-2">&nbsp;</label>
                      <button
                        className="btn btn-info btn-rounded"
                        style={{ width: "100%" }}
                        onClick={handleDownloadBankProof}
                      >
                        <i className="fa fa-certificate"></i> Account Confirmation
                      </button>
                    </div>
                  </div>
                  <div className="card-body">
                      <div className="table-responsive">
                      {((filter.transactionCurrency === "EUR"
                          ? filteredIBANEURAccountTransactionHistory
                          : filteredIBANUSDAccountTransactionHistory
                        ) || []
                      ).length > 0 ? (
                        <MaterialTable
                          title={filter.transactionCurrency === "EUR" ? "EUR Account Transaction History" : "USD Account Transaction History"}
                          columns={[
                            {
                              title: (
                                <div style={{ textAlign: 'center', width: '100%', marginLeft: '20px' }}>
                                  <input
                                    type="checkbox"
                                    checked={isAllSelected()}
                                    onChange={(e) => handleSelectAll(e.target.checked)}
                                  />
                                </div>
                              ),
                              field: 'selection',
                              width: '50px',
                              sorting: false,
                              render: rowData => (
                                <div style={{ textAlign: 'center', width: '100%', marginLeft: '10px' }}>
                                  <input
                                    type="checkbox"
                                    checked={isRowSelected(rowData)}
                                    onChange={(e) => handleRowSelection(rowData, e.target.checked)}
                                  />
                                </div>
                              )
                            },
                            {
                              title: 'Date',
                              field: 'transaction_date',
                              render: rowData => (
                                <div>
                                  {moment(rowData.transaction_date).format('MMMM D, YYYY')}<br />
                                  {moment(rowData.transaction_date).format('hh:mm:ss A')}
                                </div>
                              )
                            },
                            { title: "Sender", field: "sender", render: rowData => rowData.sender || "-" },
                            { title: "Recipient", field: "recipient", render: rowData => rowData.recipient || "-" },
                            { title: "Payment Status", field: "payment_status" },
                            {
                              title: 'Debit/Credit',
                              field: 'debit_credit',
                              render: rowData => (
                                <span style={{ color: rowData.debit_credit === "CREDIT" ? "green" : "red" }}>
                                  {rowData.debit_credit}
                                </span>
                              )
                            },
                            {
                              title: 'Amount',
                              field: 'amount',
                              align: 'right',
                              render: rowData => {
                                let displayAmount = Number(rowData.amount);
                                if (
                                  rowData.debit_credit === "CREDIT" &&
                                  rowData.payment_type === "INTERNAL"
                                ) {
                                  displayAmount += Number(rowData.site_fee || 0);
                                }
                                return (
                                  <span>
                                    {rowData.currency === "EUR" ? "€" : "$"}
                                    {displayAmount.toLocaleString(undefined, { minimumFractionDigits: 2 })}
                                  </span>
                                );
                              }
                            },
                            {
                              title: "Network Fee",
                              field: 'network_fee',
                              align: 'right',
                              render: rowData => (
                                <span>
                                  {rowData.currency === "EUR" ? "€" : "$"}
                                  {isNaN(Number(rowData.network_fee))
                                    ? "0.00"
                                    : Number(rowData.network_fee).toLocaleString(undefined, { minimumFractionDigits: 2 })}
                                </span>
                              )
                            },
                            {
                              title: "Site Fee",
                              field: 'site_fee',
                              align: 'right',
                              render: rowData => (
                                <span>
                                  {rowData.currency === "EUR" ? "€" : "$"}
                                  {isNaN(Number(rowData.site_fee))
                                    ? "0.00"
                                    : Number(rowData.site_fee).toLocaleString(undefined, { minimumFractionDigits: 2 })}
                                </span>
                              )
                            },
                            {
                              title: "Payment Description",
                              field: 'narrative',
                              render: rowData => {
                                if (rowData.narrative) {
                                  return <span>{rowData.narrative}</span>;
                                }
                                return <span>-</span>;
                              }
                            },
                            {
                              title: "Action",
                              field: 'action',
                              sorting: false,
                              render: rowData => {
                                // Show "Repeat Payment" button only when conditions are met
                                if (
                                  rowData.debit_credit === "DEBIT" &&
                                  rowData.payment_type === "EXTERNAL" &&
                                  rowData.payment_status === "EXECUTED" &&
                                  rowData.beneficiary_iban_number &&
                                  rowData.beneficiary_iban_number !== ""
                                ) {
                                  return (
                                    <button
                                      className="btn btn-primary btn-sm"
                                      onClick={() => handleOpenWithdrawalModal(rowData.currency, rowData)}
                                      title="Repeat this payment"
                                    >
                                      <i className="fa fa-repeat mr-1"></i>
                                      Repeat Payment
                                    </button>
                                  );
                                }
                                return <span>-</span>;
                              }
                            }
                          ]}
                          data={
                            filter.transactionCurrency === "EUR"
                              ? filteredIBANEURAccountTransactionHistory
                              : filteredIBANUSDAccountTransactionHistory
                          }
                          options={{
                            paging: true,
                            pageSize: 5,
                            pageSizeOptions: [5, 10, 15],
                            emptyRowsWhenPaging: false,
                            headerStyle: { fontWeight: 'bold', background: '#f8f9fa' }
                          }}
                        />
                      ) : (
                        <div className="d-sm-flex d-block border-0 pb-0">
                          <div className="pr-3 mr-auto mb-sm-0 mb-3 nofoundFullWidth">
                            <h4 className="fs-20 text-black mb-1 nofoundTitle">
                              {filter.transactionCurrency === "EUR"
                                ? "EUR Account Transaction History"
                                : "USD Account Transaction History"}
                            </h4>
                            <span className="fs-12 nofoundText">Transaction history not available</span>
                          </div>
                        </div>
                      )}
                      </div>
                  </div>
                </div>
              </div>
              </>
            ) : (
              <div className="col-12">
                <p className="text-center text-muted">No accounts available</p>
              </div>
            )}
            </div>

            {/* Transfer Modal */}
            <Modal show={showTransferModal} onHide={handleCloseTransferModal} centered>
              <Modal.Header closeButton>
                <Modal.Title>Transfer</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="d-flex justify-content-between align-items-center">
                  <div className="w-45">
                    <label>From</label>
                    <select className="form-control" value={transferFrom} disabled>
                      <option>{transferFrom}</option>
                    </select>
                  </div>
                  <div className="mx-3 mt-4">
                    <i className="fa fa-arrow-right" style={{ fontSize: "1.5rem" }}></i>
                  </div>
                  <div className="w-45">
                    <label>To</label>
                    <select className="form-control" value={transferTo} disabled>
                      <option>{transferTo}</option>
                    </select>
                  </div>
                </div>
                <div className="form-group mt-4">
                  <label>Amount ({transferCurrency})</label>
                  <input
                    type="number"
                    className="form-control"
                    min="0"
                    value={transferAmount}
                    onChange={e => setTransferAmount(e.target.value)}
                    placeholder={`Enter amount in ${transferCurrency}`}
                    required
                  />
                  {transferAmountError && (
                    <small className="text-danger">{transferAmountError}</small>
                  )}
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Link to="#" className="btn btn-light btn-rounded" onClick={handleCloseTransferModal}>Cancel</Link>
                <Button className="btn btn-primary btn-rounded" onClick={handleTransferSubmit}>
                  Submit
                </Button>
              </Modal.Footer>
            </Modal>

            {/* Withdrawal Modal */}
            <Modal show={showWithdrawalModal} onHide={handleCloseWithdrawalModal} centered>
              <Modal.Header closeButton>
                <Modal.Title>
                  {isRepeatPayment ? "Repeat Withdrawal Payment" : "Withdrawal"}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="row">
                  <div className="col-md-12">
                      <div className="form-group position-relative">
                      <label className="mb-2">Amount ({formData.withdrawal_currency})<span className="text-danger">*</span></label>
                      <input
                      type="number"
                      className="form-control"
                      name="withdrawal_amount"
                      value={formData.withdrawal_amount}
                      onChange={handleInputChange}
                      placeholder={`Enter amount in ${formData.withdrawal_currency}`}
                      required
                      />
                      {errors.withdrawal_amount && <small className="text-danger">{errors.withdrawal_amount}</small>}
                      </div>
                  </div>
                  {/* Beneficiary Section */}
                  <div className="col-12 mt-4">
                      <h4 className="text-black font-w500 mb-3">Beneficiary Details</h4>
                  </div>
                  <div className="col-md-12">
                      <div className="form-group position-relative">
                      <label className="mb-2">Select Beneficiary</label>
                      <select
                        className="form-control"
                        value={selectedBeneficiary}
                        onChange={(e) => handleBeneficiarySelect(e.target.value)}
                      >
                        <option value="">+ Add New Beneficiary</option>
                        {beneficiaries.map((beneficiary) => (
                          <option key={beneficiary.beneficiary_id} value={beneficiary.beneficiary_id}>
                            {beneficiary.beneficiary_name} - {beneficiary.beneficiary_iban_number}
                          </option>
                        ))}
                      </select>
                      </div>
                  </div>
                  <div className="col-md-12">
                      <div className="form-group position-relative">
                      <label className="mb-2">Beneficiary Name / Business Name <span className="text-danger">*</span></label>
                      <input
                      type="text"
                      className="form-control"
                      name="beneficiary_name"
                      value={formData.beneficiary_name}
                      onChange={handleInputChange}
                      placeholder="Enter beneficiary name or business name"
                      required
                      />
                      {errors.beneficiary_name && <small className="text-danger">{errors.beneficiary_name}</small>}
                      </div>
                  </div>
                  <div className="col-md-12">
                      <div className="form-group position-relative">
                      <label className="mb-2">Beneficiary Type <span className="text-danger">*</span></label>
                      <select
                        className="form-control"
                        name="beneficiary_type"
                        value={formData.beneficiary_type}
                        onChange={handleInputChange}
                      >
                        <option value="INDIVIDUAL">Individual</option>
                        <option value="BUSINESS">Business</option>
                      </select>
                      </div>
                  </div>
                  <div className="col-md-12">
                      <div className="form-group position-relative">
                      <label className="mb-2">IBAN Number <span className="text-danger">*</span></label>
                      <input
                      type="text"
                      className="form-control"
                      name="beneficiary_iban_number"
                      value={formData.beneficiary_iban_number}
                      onChange={handleInputChange}
                      placeholder="Enter IBAN number"
                      required
                      />
                      {errors.beneficiary_iban_number && <small className="text-danger">{errors.beneficiary_iban_number}</small>}
                      </div>
                  </div>
                  <div className="col-md-12">
                      <div className="form-group position-relative">
                      <label className="mb-2">Payment Description / Reason for Transfer <span className="text-danger">*</span></label>
                      <textarea
                      className="form-control"
                      name="payment_description"
                      value={formData.payment_description}
                      onChange={handleInputChange}
                      placeholder="Enter payment description or reason for transfer"
                      rows="3"
                      required
                      />
                      {errors.payment_description && <small className="text-danger">{errors.payment_description}</small>}
                      </div>
                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Link to="#" className="btn btn-light btn-rounded" onClick={handleCloseWithdrawalModal}>Cancel</Link>
                <Button className="btn btn-primary btn-rounded" onClick={handleWithdrawalSubmit}>
                  Submit
                </Button>
              </Modal.Footer>
            </Modal>
          </>
        )}
        </div>
      </>
    )}
  </>
  );
};

export default IBANAccount;